module.exports = __webpack_public_path__ + "static/media/Draco Malfoy 1.abab8508.jpg";